export default __webpack_public_path__ + "static/media/vit.6b9ad280.jpg";